import { render, staticRenderFns } from "./GerenciamentoServicoListFiltroModalItemInputTransportadora.vue?vue&type=template&id=322ebc13"
import script from "./GerenciamentoServicoListFiltroModalItemInputTransportadora.vue?vue&type=script&lang=js"
export * from "./GerenciamentoServicoListFiltroModalItemInputTransportadora.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports